import React from 'react'
import PropTypes from 'prop-types'
import { Promotion } from 'LiveBoard/components/shared/Promotion'

const PromotionRenderer = (props) => {
  const renderPromotion = promoArea => {
    return (
      props.showPromotion && (
        <Promotion
          numberOfItemsPerSlide={props.isMobile ? 1 : 2}
          index={promoArea.index+1}
          key={promoArea.key}
          config={promoArea}
          themeColorHex={props.themeColorHex} />
        )
      )
  }

  return renderPromotion(props.area)
}

PromotionRenderer.propTypes = {
  showPromotion: PropTypes.bool,
  themeColorHex: PropTypes.string,
  area: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired
}

export default PromotionRenderer